import { observer } from "mobx-react";

import { Box } from "@mui/material";
import FormTextField from "../components/fields/FormTextField";
import React from "react";

function PhoneNumberFormRow({ gap = 2, form, areaCodeFieldName, phoneNumber, onBlur}) {
    return (
        <Box display="flex" width="100%" gap={gap}>
            <Box flex="0 0 9%">
                <FormTextField
                    label="Código de Area"
                    form={form}
                    fieldName={areaCodeFieldName}
                    onBlur={onBlur}
                />
            </Box>
            <Box flex="0 0 38.3%">
                <FormTextField
                    label="Teléfono"
                    form={form}
                    fieldName={phoneNumber}
                    onBlur={onBlur}
                />
            </Box>
        </Box>
    );
}
export default observer(PhoneNumberFormRow);
